// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".charts-sidebar {\n  height: calc(100vh - 64px);\n  position: sticky;\n  top: 64px;\n  z-index: 10;\n}\n", ""]);
// Exports
module.exports = exports;
